"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doctolibPlanningSyncRunApiResponseSchema = exports.triggerDoctolibPlanningSyncApiResponseSchema = exports.triggerDoctolibPlanningSyncApiPayloadSchema = void 0;
const zod_1 = require("zod");
/**
 * Returns `true` when `value` is a valid `YYYY-MM-DD` calendar date.
 *
 * Parses the string and checks it round-trips to the same value, so
 * month/day overflow (e.g. `2026-13-99`) is rejected.
 */
const isRealCalendarDate = (value) => {
    const date = new Date(`${value}T00:00:00.000Z`);
    return (!Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value);
};
/**
 * Payload to trigger a manual Doctolib planning synchronisation for an office
 * over an inclusive date range.
 *
 * `from` is the inclusive start date and `to` the inclusive end date, both in
 * `YYYY-MM-DD` format, with `from` on or before `to`.
 */
exports.triggerDoctolibPlanningSyncApiPayloadSchema = zod_1.z
    .object({
    officeId: zod_1.z.string().min(1),
    from: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .refine(isRealCalendarDate, { message: 'Invalid date' }),
    to: zod_1.z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .refine(isRealCalendarDate, { message: 'Invalid date' }),
})
    .refine(({ from, to }) => from <= to, {
    message: '`from` must be on or before `to`',
    path: ['to'],
});
exports.triggerDoctolibPlanningSyncApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        runId: zod_1.z.string(),
    }),
});
exports.doctolibPlanningSyncRunApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        runId: zod_1.z.string(),
        status: zod_1.z.enum([
            'QUEUED',
            'WAITING_FOR_DEPLOY',
            'EXECUTING',
            'COMPLETED',
            'FAILED',
            'CANCELED',
            'TIMED_OUT',
            'CRASHED',
            'INTERRUPTED',
            'SYSTEM_FAILURE',
            'EXPIRED',
        ]),
        terminal: zod_1.z.boolean(),
        success: zod_1.z.boolean().nullable(),
        humanReport: zod_1.z.string().optional(),
        counts: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional(),
        writeResultsTotal: zod_1.z.number().optional(),
        writeResultsSucceeded: zod_1.z.number().optional(),
        writeResultsFailed: zod_1.z.number().optional(),
        writeResultsSkipped: zod_1.z.number().optional(),
        errorMessage: zod_1.z.string().optional(),
    }),
});
